module.exports = __webpack_public_path__ + "agency/e4ab9ae64f255aab31b92aa3e3952be9.png";